/**
 * Safely parse GraphQL/API payloads that may already be objects,
 * empty, or non-JSON (e.g. HTML/XML error bodies).
 * @param {*} raw
 * @param {*} [fallback=null]
 * @returns {*}
 */
export function parseApiJson(raw, fallback = null) {
  if (raw == null || raw === "") {
    return fallback;
  }

  if (typeof raw === "object") {
    return raw;
  }

  if (typeof raw !== "string") {
    return fallback;
  }

  const trimmed = raw.replace(/^\uFEFF/, "").trim();
  if (!trimmed) {
    return fallback;
  }

  const first = trimmed[0];
  if (first !== "{" && first !== "[") {
    console.error(
      "parseApiJson: expected JSON, got:",
      trimmed.slice(0, 160)
    );
    return fallback;
  }

  try {
    return JSON.parse(trimmed);
  } catch (error) {
    console.error("parseApiJson failed:", error, trimmed.slice(0, 160));
    return fallback;
  }
}
